module.exports = __webpack_public_path__ + "static/media/ziplyne-logo.72e77b20.png";